const NDCLogoIcon = () => {
  return (
    <svg
      width="59"
      height="24"
      viewBox="0 0 59 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3535_240)">
        <path
          d="M57.5815 14.1216C56.3154 13.488 54.7715 13.9944 54.1336 15.2544C52.9932 17.5032 50.7945 18.9 48.3929 18.9C44.8049 18.9 41.8813 15.804 41.8813 12C41.8813 8.196 44.8025 5.1 48.3929 5.1C50.6882 5.1 52.8386 6.4032 54.0056 8.5008C54.6918 9.7344 56.2526 10.1808 57.4945 9.4992C58.7364 8.8176 59.1858 7.2672 58.4996 6.0336C56.4266 2.3136 52.5535 0 48.3929 0C41.9731 0 36.7494 5.3832 36.7494 12C36.7494 12.0984 36.7422 12.2928 36.7349 12.2928C36.5875 15.96 33.7365 18.9 30.2379 18.9C30.076 18.9 29.9165 18.8928 29.7595 18.8808C28.3388 18.7872 27.1186 19.8432 27.022 21.2496C26.9229 22.6536 27.9909 23.8728 29.4067 23.9688C29.6822 23.988 29.9625 23.9976 30.2403 23.9976C33.908 23.9976 37.1771 22.2336 39.3154 19.4928C41.4513 22.236 44.7276 23.9976 48.3977 23.9976C52.7516 23.9976 56.7117 21.5256 58.7267 17.544C59.3646 16.2864 58.8548 14.7528 57.5863 14.1192H57.5839L57.5815 14.1216Z"
          fill="#FFE100"
        />
        <path
          d="M17.1329 13.8912C17.1329 13.8912 4.40464 0.7728 4.40223 0.7704C3.93591 0.2952 3.28597 0 2.56595 0C1.15009 0 0 1.1424 0 2.5488V21.4488C0 22.8552 1.15009 23.9976 2.56595 23.9976C3.98182 23.9976 5.13191 22.8552 5.13191 21.4488V8.868L17.1305 21.2376V13.8864L17.1329 13.8912Z"
          fill="#FFE100"
        />
        <path
          d="M38.4095 3.4656C36.305 1.3248 33.4202 0 30.2357 0H21.0132C19.5974 0 18.4473 1.1424 18.4473 2.5488V21.4488C18.4473 22.8552 19.5974 23.9976 21.0132 23.9976C22.4291 23.9976 23.5792 22.8552 23.5792 21.4488V5.1H30.2357C32.6277 5.1 34.7176 6.4752 35.8508 8.5176C36.3461 6.6384 37.228 4.9224 38.4095 3.4656Z"
          fill="#FFE100"
        />
      </g>
      <defs>
        <clipPath id="clip0_3535_240">
          <rect width="59" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default NDCLogoIcon
